import { usePageTitle } from '../hooks/usePageTitle';
import React, { useEffect, useState } from 'react';
import api, { BASE_URL, fotoUrl } from '../api';
import { useAuth } from '../AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const Yoklama: React.FC = () => {
  usePageTitle('Yoklama');
  const { kullanici } = useAuth();
  const { isDark } = useTheme();
  const card        = isDark ? '#1a1a1a' : 'white';
  const cardAlt     = isDark ? '#1e1e1e' : '#f8f8f8';
  const cardHover   = isDark ? '#252525' : '#fafafa';
  const border      = isDark ? '#2a2a2a' : '#eee';
  const borderSub   = isDark ? '#202020' : '#f0f0f0';
  const textPrimary = isDark ? '#e8e8e8' : '#1a1a1a';
  const textSec     = isDark ? '#999'    : '#888';
  const textMuted   = isDark ? '#666'    : '#aaa';
  const [dersler, setDersler] = useState<any[]>([]);
  const [seciliDers, setSeciliDers] = useState<any>(null);
  const [ogrenciler, setOgrenciler] = useState<any[]>([]);
  const [durumlar, setDurumlar] = useState<any>({});
  const [egitmenNot, setEgitmenNot] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [yoklamaAlindi, setYoklamaAlindi] = useState(false);
  const [yoklamaId, setYoklamaId]     = useState<string | null>(null);
  const [geriAliniyor, setGeriAliniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [basari, setBasari] = useState('');

  const bugun = new Date().toISOString().split('T')[0];
  const bugunGun = ['Paz','Pzt','Sal','Çar','Per','Cum','Cmt'][new Date().getDay()];

  useEffect(() => {
    api.get('/api/dersler').then(res => {
      setDersler(res.data);
    });
  }, []);

  const dersSec = async (ders: any) => {
    setSeciliDers(ders);
    setOgrenciler([]);
    setDurumlar({});
    setEgitmenNot('');
    setHata('');
    setBasari('');
    setYukleniyor(true);
    try {
      const res = await api.get(`/api/yoklama/ders/${ders.id}/bugun`);
      setOgrenciler(res.data.ogrenciler);
      setYoklamaAlindi(res.data.yoklama_alindi);
      setYoklamaId(res.data.yoklama_id || null);
      const baslangicDurumlar: any = {};
      res.data.ogrenciler.forEach((o: any) => {
        baslangicDurumlar[o.id] = 'gelmedi';
      });
      setDurumlar(baslangicDurumlar);
    } catch (err: any) {
      setHata(err.response?.data?.hata || 'Ogrenciler yuklenemedi');
    } finally { setYukleniyor(false); }
  };

  const yoklamaGeriAl = async () => {
    if (!yoklamaId) return;
    if (!window.confirm(`"${seciliDers?.ad}" dersinin bugünkü yoklaması geri alınacak.\n\nKatılan öğrencilerin ders hakları iade edilecek, hakedişler sıfırlanacak.\n\nEmin misiniz?`)) return;
    setGeriAliniyor(true);
    try {
      const res = await api.delete(`/api/yoklama/oturum/${yoklamaId}`);
      setYoklamaAlindi(false);
      setYoklamaId(null);
      setBasari(`Yoklama geri alındı. ${res.data.katildi_sayisi} öğrencinin ders hakkı iade edildi.`);
      setDurumlar({});
    } catch (err: any) {
      setHata(err.response?.data?.hata || 'Geri alınamadı');
    } finally { setGeriAliniyor(false); }
  };

  const kaydet = async () => {
    if (!seciliDers) return;
    setKaydediliyor(true); setHata(''); setBasari('');
    try {
      const satirlar = ogrenciler.map(o => ({
        ogrenci_id: o.id,
        durum: durumlar[o.id] || 'gelmedi',
        birim_fiyat_snapshot: o.birim_fiyat || 0,
        egitmen_oran: seciliDers.egitmenler?.[0]?.hakedis_oran || 25,
      }));

      const res = await api.post('/api/yoklama', {
        ders_id: seciliDers.id,
        tarih: bugun,
        satirlar,
        egitmen_notu: egitmenNot,
      });

      const k = satirlar.filter(s => s.durum === 'katildi').length;
      const g = satirlar.filter(s => s.durum === 'gelmedi').length;
      setBasari(`Yoklama kaydedildi! Katildi: ${k}, Gelmedi: ${g}. Hakedis: ₺${res.data.toplam_hakedis}`);
      setYoklamaAlindi(true);
    } catch (err: any) {
      setHata(err.response?.data?.hata || 'Kayit basarisiz');
    } finally { setKaydediliyor(false); }
  };

  const katildiSayisi = Object.values(durumlar).filter(d => d === 'katildi').length;
  const gelmediSayisi = Object.values(durumlar).filter(d => d === 'gelmedi').length;

  const katildiOgrenciler = ogrenciler.filter(o => durumlar[o.id] === 'katildi');
  const toplamGelir = katildiOgrenciler.reduce((sum, o) => sum + parseFloat(o.birim_fiyat || 0), 0);
  const ucretsizSayisi = katildiOgrenciler.filter(o => !parseFloat(o.birim_fiyat || 0)).length;

  const RENKLER = [
    ['#EEEDFE','#3C3489'], ['#E1F5EE','#085041'], ['#FBEAF0','#72243E'],
    ['#FAEEDA','#854F0B'], ['#EAF3DE','#3B6D11'],
  ];

  return (
    <div style={{ padding:24 }}>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:22, fontWeight:600, margin:0 }}>Yoklama al</h1>
        <div style={{ fontSize:13, color:textSec, marginTop:4 }}>
          {new Date().toLocaleDateString('tr-TR', { weekday:'long', year:'numeric', month:'long', day:'numeric' })}
        </div>
      </div>

      {/* Ders secimi */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px, 1fr))', gap:10, marginBottom:20 }}>
        {dersler.length === 0 && (
          <div style={{ gridColumn:'1/-1', color:'#aaa', fontSize:13 }}>Hic ders bulunamadi.</div>
        )}
        {dersler.map(d => {
          const bugunSeans = d.seanslar?.find((s:any) => s.gun === bugunGun);
          const secili = seciliDers?.id === d.id;
          return (
            <div key={d.id} onClick={() => dersSec(d)}
              style={{
                background: secili ? '#534AB7' : card,
                border: secili ? '2px solid #534AB7' : `1px solid ${border}`,
                borderRadius:10, padding:14, cursor:'pointer',
                transition:'all .15s',
                opacity: bugunSeans ? 1 : 0.5,
              }}>
              <div style={{ fontWeight:600, fontSize:13, color: secili ? 'white' : textPrimary, marginBottom:4 }}>{d.ad}</div>
              <div style={{ fontSize:11, color: secili ? 'rgba(255,255,255,0.7)' : textMuted }}>
                {bugunSeans ? `Bugun ${String(bugunSeans.baslangic_saat).slice(0,5)}` : 'Bugun dersi yok'}
              </div>
              <div style={{ fontSize:11, color: secili ? 'rgba(255,255,255,0.7)' : textMuted, marginTop:2 }}>
                {d.egitmenler?.map((e:any) => e.egitmen_adi).join(', ') || 'Egitmen atanmamis'}
              </div>
            </div>
          );
        })}
      </div>

      {/* Yoklama listesi */}
      {seciliDers && (
        <div>
          {yoklamaAlindi && (
            <div style={{ background: isDark ? 'rgba(245,158,11,0.15)' : '#FAEEDA', border:'1px solid #F5A623', borderRadius:8, padding:'10px 14px', fontSize:13, color:'#854F0B', marginBottom:14, display:'flex', alignItems:'center', justifyContent:'space-between', gap:12 }}>
              <span>Bu ders için bugün yoklama zaten alınmış. Tekrar kaydederseniz güncellenir.</span>
              {yoklamaId && (
                <button
                  onClick={yoklamaGeriAl}
                  disabled={geriAliniyor}
                  style={{ flexShrink:0, background:'#854F0B', color:'white', border:'none', padding:'5px 12px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:600, opacity: geriAliniyor ? 0.6 : 1 }}>
                  {geriAliniyor ? 'İşleniyor...' : 'Geri Al'}
                </button>
              )}
            </div>
          )}

          {yukleniyor ? (
            <div style={{ textAlign:'center', color:textSec, padding:40 }}>Yukleniyor...</div>
          ) : ogrenciler.length === 0 ? (
            <div style={{ background:card, border:'1px dashed #ddd', borderRadius:10, padding:32, textAlign:'center', color:textMuted }}>
              Bu derse kayitli aktif ogrenci bulunamadi.
            </div>
          ) : (
            <div style={{ background:card, border:`1px solid ${border}`, borderRadius:10, overflow:'hidden', marginBottom:14 }}>
              <div style={{ padding:'12px 16px', borderBottom:`1px solid ${border}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <div style={{ fontWeight:600, fontSize:14 }}>{seciliDers.ad}</div>
                <div style={{ display:'flex', gap:8, fontSize:12 }}>
                  <span style={{ background: isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE', color:'#3B6D11', borderRadius:20, padding:'2px 10px' }}>Katildi: {katildiSayisi}</span>
                  <span style={{ background: isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color:'#A32D2D', borderRadius:20, padding:'2px 10px' }}>Gelmedi: {gelmediSayisi}</span>
                </div>
              </div>

              {ogrenciler.map((o, i) => {
                const durum = durumlar[o.id] || 'gelmedi';
                const [bg, tc] = RENKLER[i % RENKLER.length];
                return (
                  <div key={o.id} style={{
                    display:'flex', alignItems:'center', justifyContent:'space-between',
                    padding:'12px 16px',
                    borderBottom: i < ogrenciler.length-1 ? `1px solid ${borderSub}` : 'none',
                    background: durum==='katildi' ? isDark ? 'rgba(29,158,117,0.1)' : '#f0faf5' : card,
                    transition:'background .15s',
                  }}>
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                      {o.foto_url
                        ? <img src={fotoUrl(o.foto_url)} alt="" style={{ width:32, height:32, borderRadius:'50%', objectFit:'cover' }} />
                        : <div style={{ width:32, height:32, borderRadius:'50%', background:bg, color:tc, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:600 }}>
                            {o.ad?.charAt(0)}{o.soyad?.charAt(0)}
                          </div>
                      }
                      <div>
                        <div style={{ fontWeight:500, fontSize:13 }}>{o.ad} {o.soyad}</div>
                        <div style={{ fontSize:11, color:textMuted }}>
                          {o.kalan_hak} hak · ₺{parseFloat(o.birim_fiyat||0).toLocaleString('tr-TR')} birim
                        </div>
                      </div>
                    </div>

                    <div style={{ display:'flex', gap:6 }}>
                      {o.kalan_hak <= 0 && (
                        <span style={{ background: isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color:'#A32D2D', borderRadius:20, padding:'3px 8px', fontSize:11 }}>Hak yok</span>
                      )}
                      <div style={{ display:'flex', borderRadius:6, overflow:'hidden', border:'1px solid #ddd' }}>
                        <button
                          onClick={() => setDurumlar((p:any) => ({...p, [o.id]:'katildi'}))}
                          style={{
                            padding:'6px 14px', border:'none', cursor:'pointer', fontSize:12,
                            background: durum==='katildi' ? '#1D9E75' : card,
                            color: durum==='katildi' ? 'white' : isDark ? '#bbb' : '#555',
                            fontWeight: durum==='katildi' ? 600 : 400,
                          }}>Katildi</button>
                        <button
                          onClick={() => setDurumlar((p:any) => ({...p, [o.id]:'gelmedi'}))}
                          style={{
                            padding:'6px 14px', border:'none', borderLeft:'1px solid #ddd', cursor:'pointer', fontSize:12,
                            background: durum==='gelmedi' ? '#E24B4A' : card,
                            color: durum==='gelmedi' ? 'white' : isDark ? '#bbb' : '#555',
                            fontWeight: durum==='gelmedi' ? 600 : 400,
                          }}>Gelmedi</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {ogrenciler.length > 0 && (
            <>
              {/* Gelir ve hakedis özeti */}
              {katildiSayisi > 0 && (
                <div style={{ background: isDark ? '#111' : '#f7f7ff', border:`1px solid ${isDark ? '#2a2a5a' : '#dddcf7'}`, borderRadius:10, padding:'14px 16px', marginBottom:14 }}>
                  <div style={{ fontWeight:600, fontSize:13, marginBottom:10, color: isDark ? '#bbb' : '#444' }}>Oturum özeti</div>
                  <div style={{ display:'flex', gap:8, flexWrap:'wrap' as const, marginBottom:10 }}>
                    <div style={{ flex:1, minWidth:120, background: isDark ? '#1a1a3a' : '#EEEDFE', borderRadius:8, padding:'10px 12px' }}>
                      <div style={{ fontSize:11, color: isDark ? '#888' : '#888', marginBottom:2 }}>Ders geliri</div>
                      <div style={{ fontSize:18, fontWeight:700, color:'#3C3489' }}>
                        ₺{toplamGelir.toLocaleString('tr-TR', { minimumFractionDigits:0, maximumFractionDigits:0 })}
                      </div>
                      <div style={{ fontSize:10, color: isDark ? '#666' : '#aaa', marginTop:2 }}>
                        {katildiSayisi - ucretsizSayisi} ücretli{ucretsizSayisi > 0 ? `, ${ucretsizSayisi} ücretsiz` : ''}
                      </div>
                    </div>
                  </div>
                  {seciliDers?.egitmenler?.filter((eg: any) => eg.hakedis_oran > 0).map((eg: any) => {
                    const egHakedis = toplamGelir * (eg.hakedis_oran / 100);
                    return (
                      <div key={eg.egitmen_id || eg.egitmen_adi} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'6px 0', borderTop:`1px solid ${isDark ? '#222' : '#e8e8f5'}` }}>
                        <div>
                          <span style={{ fontSize:12, fontWeight:500 }}>{eg.egitmen_adi}</span>
                          <span style={{ fontSize:11, color:textMuted, marginLeft:6 }}>%{eg.hakedis_oran} hakediş</span>
                        </div>
                        <span style={{ fontSize:14, fontWeight:600, color:'#534AB7' }}>
                          ₺{egHakedis.toLocaleString('tr-TR', { minimumFractionDigits:0, maximumFractionDigits:0 })}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}

              <div style={{ marginBottom:12 }}>
                <div style={{ fontSize:12, fontWeight:500, marginBottom:6, color: isDark ? '#bbb' : '#555' }}>Ders notu (opsiyonel)</div>
                <textarea value={egitmenNot} onChange={e=>setEgitmenNot(e.target.value)}
                  placeholder="Bu derse ait notlar, calisilan teknikler..."
                  style={{ width:'100%', padding:'10px 12px', borderRadius:8, border:'1px solid #ddd', fontSize:13, resize:'vertical', minHeight:80, boxSizing:'border-box', fontFamily:'sans-serif' }} />
              </div>

              {hata && <div style={{ background: isDark ? 'rgba(228,75,74,0.15)' : '#FCEBEB', color:'#A32D2D', padding:'10px 14px', borderRadius:8, fontSize:13, marginBottom:12 }}>{hata}</div>}
              {basari && <div style={{ background: isDark ? 'rgba(29,158,117,0.15)' : '#EAF3DE', color:'#3B6D11', padding:'10px 14px', borderRadius:8, fontSize:13, marginBottom:12 }}>{basari}</div>}

              <button onClick={kaydet} disabled={kaydediliyor}
                style={{ background:'#534AB7', color:'white', border:'none', padding:'12px 24px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:500, width:'100%' }}>
                {kaydediliyor ? 'Kaydediliyor...' : 'Yoklamayi kaydet'}
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Yoklama;
